import CommunityObject from "./CommunityObject";
import Scenario from "./ScenarioObject";
import Tag from "./TagObject";
export default class UserObject extends CommunityObject {
  constructor(user) {
    super(UserObject.name);
    this.id = Number(user.id);
    this.uuid = String(user.uuid_id);
    this.first_name = String(user.first_name);
    this.last_name = String(user.last_name);
    this.mobile_phone = String(user.mobile_phone);
    this.favourited_scenarios = [];
    if (user.favourited_scenarios) {
      user.favourited_scenarios.forEach(scenario => {
        this.favourited_scenarios.push(new Scenario(scenario));
      });
    }
    this.validate();
  }
  static toJSON() {
    id: this.id;
    uuid_id: this.uuid_id;
    first_name: this.first_name;
    last_name: this.last_name;
    mobile_phone: this.mobile_phone;
    favourited_scenarios: this.favourited_scenarios;
  }
}
